import React from "react";
import leafIcon from "../../../../../assets/images/Event-2025/reel-leaf.png";
import addSlot from "../../../../../assets/images/Event-2025/reel-add-slot.png";
import bidIcon from "../../../../../assets/images/Event-2025/reel-bid.png";
import puzzleIcon from "../../../../../assets/images/Event-2025/reel-puzzle.png";
import SlotCounter from "react-slot-counter";
import styled from "styled-components";
import { ID_GIFT_PLAY_LOTO } from "../../../../../helper/const";

const dummyCharacterCountTime = 6;
const durationTime = 4;
export default function LotoReel({ isStart = true, dataCongratesApi = {} }) {
  const option = [
    <img className="item-1 img-container" src={leafIcon} alt="" />,
    <img className="item-2 img-container" src={puzzleIcon} alt="" />,
    <img className="item-3 img-container" src={bidIcon} alt="" />,
    <img className="item-3 img-container" src={addSlot} alt="" />,
  ];

  let gift = null;
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.good_luck) {
    gift = leafIcon;
  }
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.add_spin) {
    gift = addSlot;
  }
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.bid_free) {
    gift = bidIcon;
  }
  if (+dataCongratesApi.id === ID_GIFT_PLAY_LOTO.puzzle_piece) {
    gift = puzzleIcon;
  }

  return (
    <Container>
      <SlotCounter
        startValue={[
          <img className="item-2 img-container" src={gift ||bidIcon} alt="" />,
        ]}
        value={[<img className="item-4 img-container" src={gift || bidIcon} alt="" />]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={isStart ? durationTime : 0}
      />

      <SlotCounter
        value={[<img className="item-5 img-container" src={gift || leafIcon} alt="" />]}
        startValue={[
          <img className="item-2 img-container" src={leafIcon} alt="" />,
        ]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={isStart ? durationTime : 0}
      />
      <SlotCounter
      startValue={[
        <img className="item-2 img-container" src={addSlot} alt="" />,
      ]}
        value={[<img className="item-6 img-container" src={gift || addSlot} alt="" />]}
        dummyCharacters={option}
        dummyCharacterCount={dummyCharacterCountTime}
        duration={isStart ? durationTime : 0}
      />
    </Container>
  );
}

const Container = styled.span`
  display: block;

  .index-module_slot_wrap__ZT-DX {
    position: relative;
    left: -10px;
  }

  .index-module_slot_wrap__ZT-DX:first-child {
    position: relative;
    left: -65px;
  }

  .index-module_slot_wrap__ZT-DX:last-child {
    position: relative;
    left: 45px;
  }

  .index-module_slot__DpPgW,
  .index-module_num__j6XH3 {
    height: 190px;
    position: relative;
    top: 52px;
  }

  .img-container {
    position: relative;
    top: 5px;
  }

  .index-module_num__j6XH3 {
    width: 124px;
  }

  @media (max-width: 1400px) {
    .img-container {
      width: 95px;
      top: -4px;
    }

    .index-module_slot_wrap__ZT-DX:first-child {
      left: -40px;
    }

    .index-module_slot_wrap__ZT-DX:last-child {
      left: 24px;
    }

    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 160px;
      position: relative;
      top: 47px;
    }
  }

  @media (max-width: 1200px) {
    .img-container {
      width: 80px;
      top: -4px;
    }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      left: -8px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      left: -17px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: 2px;
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 140px;
      top: 43px;
    }
  }

  @media (max-width: 1075px) {
    .img-container {
      width: 70px;
      top: -4px;
    }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      left: -8px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      left: -8px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: -8px;
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 130px;
      top: 43px;
    }
  }

  @media (max-width: 992px) {
    .index-module_slot_wrap__ZT-DX:first-child {
      left: -16px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: 0px;
    }
  }

  @media (max-width: 768px) {
    .index-module_slot_wrap__ZT-DX:first-child {
      left: -10px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left:-8px;
    }
  }

  @media (max-width: 576px) {
    .img-container {
      top: 0px;
      width: auto;
      height: 50px;
    }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      left: -5px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      left: 13px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: -26px;
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 100px;
      top: 25px;
    }
  }

  @media (max-width: 492px) {
    .img-container {
      width: auto;
      top: -10px;
      height: 50px;
    }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      left: -5px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      left: 37px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: -48px;
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 82px;
      top: 25px;
    }
  }

  @media (max-width: 412px) {
    .img-container {
      width: auto;
      top: -10px;
    }

   .index-module_slot__DpPgW{
    width: 95px;
   }
    .index-module_slot_wrap__ZT-DX {
      position: relative;
      left: -5px;
    }
    .index-module_slot_wrap__ZT-DX:nth-child(2) {
      left: -18px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      left: 2px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: -36px;
    }
    .index-module_slot__DpPgW,
    .index-module_num__j6XH3 {
      height: 80px;
      top: 29px;
    }
  }

  @media (max-width: 375px) {
    .index-module_slot_wrap__ZT-DX:nth-child(2) {
      left: -17px;
    }
    .index-module_slot_wrap__ZT-DX:first-child {
      left: 8px;
    }
    .index-module_slot_wrap__ZT-DX:last-child {
      left: -44px;
    }
  }
`;
